import React from "react";
import { Box, FormGroup } from "@mui/material";
import RequestStatusRow from "./RequestStatusRow";

/**
 * マイページ公開/非公開のSwitch表示コンポーネント
 *
 * state管理やAPI通信は親コンポーネント側で行う。
 * 見た目だけを担当する。
 */
const ProfileVisibilitySwitch = ({
  isProfilePublic,
  isProfileUpdating,
  profileStatusError,
  profileStatusErrorMessage,
  onToggleProfile,
  disabled = false,
}) => {
  const rowStyle = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    width: "100%",
    flexWrap: "wrap",
  };

  const labelStyle = () => ({
    width: "140px",
    flexShrink: 0,
    fontSize: "1rem",
    color: "text.primary",
    opacity: 1,
  });

  // Switch と label の並びスタイル
  const formControlLabelStyle = {
    m: 0,
    width: "200px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    ".MuiFormControlLabel-label": {
      display: "flex",
      alignItems: "center",
    },
  };

  return (
    <Box>
      <FormGroup
        sx={{
          alignItems: "flex-start",
          gap: 1,
        }}
      >
        <RequestStatusRow
          label="マイページ公開"
          isLoading={false}
          isActive={isProfilePublic}
          isMissing={false}
          isDisabled={disabled}
          isUpdating={isProfileUpdating}
          onToggle={onToggleProfile}
          showGuide={false}
          onClickGuide={null}
          showError={profileStatusError}
          errorMessage={profileStatusErrorMessage}
          rowStyle={rowStyle}
          labelStyle={labelStyle}
          formControlLabelStyle={formControlLabelStyle}
        />
      </FormGroup>
    </Box>
  );
};

export default ProfileVisibilitySwitch;
